import { render, staticRenderFns } from "./SignupView.vue?vue&type=template&id=04f3e7d2&scoped=true&"
import script from "./SignupView.vue?vue&type=script&lang=js&"
export * from "./SignupView.vue?vue&type=script&lang=js&"
import style0 from "./SignupView.vue?vue&type=style&index=0&id=04f3e7d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f3e7d2",
  null
  
)

export default component.exports